import Cookies from "universal-cookie";

export const getExperimentsData = () => {
  const mixpanelKey = "mp_ecdbd1b26476e4332bbcd23fd903ddfa_mixpanel";
  const cookies = new Cookies();
  const mixpanelData = cookies.get(mixpanelKey);
  return mixpanelData;
};



// WEBPACK FOOTER //
// ./src/logic/utils/experimentsDataHelpers.js